import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import Footer from "./Footer";
import Header from "./Header";
import PlaneIco from "./assets/svgImages/PlaneIco.svg";
import PlaneIco1 from "./assets/svgImages/PlaneIco-2.svg";
import PlaneIco2 from "./assets/svgImages/PlaneIco-3.svg";
import downArrowIco from "./assets/img/downArrow.png";
import Traveler from "./assets/img/Traveler.png";
import LayoverImg1 from "./assets/img/LayoverImg-1.png";
import LayoverImg2 from "./assets/img/LayoverImg-2.png";
import LayoverImg3 from "./assets/img/LayoverImg-3.png";
import LayoverImg4 from "./assets/img/LayoverImg-4.png";
import LayoverImg5 from "./assets/img/LayoverImg-5.png";
import LayoverImg6 from "./assets/img/LayoverImg-6.png";
import StopPlaneImg from "./assets/img/stopPlane.png";
import PriceUpdateImg from "./assets/img/priceUpdateImg.png";
import {
  flightPriceCheck,
  flightFareRules,
  convertCurrency,
  flightExtraServices,
  getAirlineLogoUrl,
  getMarkupSettings,
} from "../services/services";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { searchFlights } from "../services/services";
import { formatDateWithWeekday } from "./formatDateWithWeekday";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toastCSS } from "../services/commonHandler";

const API_URL =
  "https://raw.githubusercontent.com/mwgg/Airports/master/airports.json";

const FlightReservationOne = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [seatClass, setSeatClass] = useState(
    location.state?.serviceClass || "Economy"
  );
  const [passengerCounts, setPassengerCounts] = useState({
    adults: 0,
    children: 0,
    infants: 0,
  });

  const [departureDate, setDepartureDate] = useState("");
  const [returnDate, setReturnDate] = useState("");
  const [airports, setAirports] = useState([]);
  const [selectedFromIATA, setSelectedFromIATA] = useState(""); // Stores IATA for From
  const [selectedToIATA, setSelectedToIATA] = useState(""); // Stores IATA for To
  const [journeyType, setJourneyType] = useState(1);
  const [childrenAges, setChildrenAges] = useState([]);
  const [isReady, setIsReady] = useState(false);
  // const { selectedFlight, selectedReturnFlight } = location.state || {};
  const layoverImages = [
    LayoverImg1,
    LayoverImg2,
    LayoverImg3,
    LayoverImg4,
    LayoverImg5,
    LayoverImg6,
  ];
  const [flightSegments, setFlightSegments] = useState(
    location.state?.segments || []
  );
  const [departureSegments, setDepartureSegments] = useState(
    location.state?.departureSegments || []
  );
  const [returnSegments, setReturnSegments] = useState(
    location.state?.returnSegments || []
  );
  useEffect(() => {
    const storedData = localStorage.getItem("flightSearchData");
    if (storedData) {
      const {
        fromLocation,
        toLocation,
        departureDate,
        returnDate,
        passengerCounts,
        seatClass,
      } = JSON.parse(storedData);

      if (fromLocation) setFromLocation(fromLocation);
      if (toLocation) setToLocation(toLocation);
      if (departureDate) setDepartureDate(departureDate);
      if (returnDate) setReturnDate(returnDate);
      if (passengerCounts) setPassengerCounts(passengerCounts);
      if (seatClass) setSeatClass(seatClass);

      // optional: clear after setting
      //   localStorage.removeItem("flightSearchData");
    }
  }, []);

  const [priceChanged, setPriceChanged] = useState(false);
  const [priceDifference, setPriceDifference] = useState(0);
  const [priceChangePercentage, setPriceChangePercentage] = useState(0);
  const [originalPrice, setOriginalPrice] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [convertedOriginalPrice, setConvertedOriginalPrice] = useState(0);
  const [convertedCurrentPrice, setConvertedCurrentPrice] = useState(0);
  const [convertedPassengerFares, setConvertedPassengerFares] = useState([]);
  const [requestAdditionalBaggage, setRequestAdditionalBaggage] =
    useState(false);
  const [isFarePriceReady, setIsFarePriceReady] = useState(false);

  const totalPassengerCount =
    passengerCounts.adults + passengerCounts.children + passengerCounts.infants;

  useEffect(() => {
    // Initialize Flatpickr separately for each field
    flatpickr("#departure-datepicker", {
      dateFormat: "Y-m-d",
      allowInput: true,
      onChange: (selectedDates, dateStr) => setDepartureDate(dateStr),
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
    });

    flatpickr("#return-datepicker", {
      dateFormat: "Y-m-d",
      allowInput: true,
      onChange: (selectedDates, dateStr) => setReturnDate(dateStr),
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
    });
  }, []);

  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const response = await axios.get(API_URL);
        const airportData = response.data;

        // Convert object to array and filter airports with valid IATA codes
        const airportList = Object.values(airportData).filter(
          (airport) => airport.iata
        );
        setAirports(airportList);
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    };
    fetchAirports();
  }, []);

  // Handle filtering for "From Location"

  const getCityByIata = (iataCode) => {
    const airport = airports.find((airport) => airport.iata === iataCode);
    return airport ? airport.city : iataCode;
    // const airport = airports.find((airport) => airport.iata === iataCode);
    // return airport ? airport.city : iataCode;
  };
  const { state } = useLocation();
  //const segments = location.state?.segments || [];
  const {
    segments = [],
    layovers = [],
    searchData = {},
    departureSegments: rtDepartureSegments = [],
    returnSegments: rtReturnSegments = [],
    departureLayovers: rtDepartureLayovers = [],
    returnLayovers: rtReturnLayovers = [],
    departureInfo,
    returnInfo,
  } = location.state || {};

  const isRoundTrip = searchData?.isRoundTrip;

  // Smartly fallback to `segments` and `layovers` for one-way
  const departureLayovers = isRoundTrip ? rtDepartureLayovers : layovers;
  const returnLayovers = isRoundTrip ? rtReturnLayovers : [];

  // Fallback for departureInfo in one-way case
  const fallbackDepartureInfo =
    !isRoundTrip && departureSegments.length > 0
      ? {
        origin: departureSegments[0].Origin,
        destination:
          departureSegments[departureSegments.length - 1].Destination,
        originCity: getCityByIata(departureSegments[0].Origin),
        destinationCity: getCityByIata(
          departureSegments[departureSegments.length - 1].Destination
        ),
        date: departureSegments[0].Departure,
      }
      : {};

  const finalDepartureInfo = departureInfo || fallbackDepartureInfo;

  const totalPrice = state.priceDetails.TotalPrice;
  const taxes = state.priceDetails.Taxes;
  const baseFare = state.priceDetails.BasePrice;
  const serviceCharge = state.priceDetails.ServiceCharge;
  const discountPrice = state.priceDetails.Discount || 0;

  const UniqueTransID = state.UniqueTransID || state.bookingInfo?.UniqueTransID;
  const ItemCodeRef = state.ItemCodeRef || state.bookingInfo?.ItemCodeRef;
  const SegmentCodeRefs =
    state.SegmentCodeRefs || state.bookingInfo?.SegmentCodeRefs;
  const priceDetailsState = state.priceDetails;
  // Function to handle count increment/decrement
  const convertPrice = async () => {
    try {
      const convertedTotal = await convertCurrency(
        currentPrice || totalPrice, // Use currentPrice if available, otherwise fallback to totalPrice
        "MYR", // You can update this based on your requirements
        preferredCurrency
      );
      setConvertedTotalPrice(convertedTotal.toFixed(2));
    } catch (error) {
      console.error("Error during currency conversion", error);
    }
  };
  useEffect(() => {
    if (currentPrice) {
      convertPrice(); // Convert price after currentPrice is updated
    }
  }, [currentPrice]);
  function calculateLayoverTime(arrival, nextDeparture) {
    const arrivalDate = new Date(arrival);
    const departureDate = new Date(nextDeparture);
    const diffMs = departureDate - arrivalDate;
    const diffMins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMins / 60);
    const minutes = diffMins % 60;
    return `${hours}h ${minutes}m`;
  }

  // Generate display text for input
  const getDisplayText = () => {
    const { adults, children, infants } = passengerCounts;
    const parts = [
      adults > 0 ? `${adults} Adult${adults > 1 ? "s" : ""}` : "",
      children > 0 ? `${children} Child${children > 1 ? "ren" : ""}` : "",
      infants > 0 ? `${infants} Infant${infants > 1 ? "s" : ""}` : "",
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : "Select Passengers";
  };

  useEffect(() => {
    // Initialize Flatpickr
    flatpickr("#datepicker", {
      dateFormat: "d/m/Y",
      allowInput: true,
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
    });
  });

  const [isOpen, setIsOpen] = useState({
    section1: true,
    section2: true,
  });

  const toggleAccordion = (section) => {
    setIsOpen((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const [priceDetails, setPriceDetails] = useState(null);
  const [fareRules, setFareRules] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (ItemCodeRef && SegmentCodeRefs && UniqueTransID) {
      //const originalTotalPrice = state?.priceDetails?.TotalPrice || state?.bookingInfo?.TotalPrice;
      const originalTotalPrice =
        state?.priceDetails?.TotalPrice || state?.bookingInfo?.TotalPrice;
      setOriginalPrice(originalTotalPrice);
      handlePriceCheck();
      handleFareRules();
      handleExtraServices();
    }
  }, [ItemCodeRef, SegmentCodeRefs, UniqueTransID]);

  //  Handle Price Check API Call
  const handlePriceCheck = async () => {
    const requestData = {
      ItemCodeRef,
      SegmentCodeRefs,
      UniqueTransID,
    };
    await flightPriceCheck(requestData, onSuccess, onError);
  };
  const onSuccess = (response) => {
    if (response?.code === 400) {
      toast.success(response?.message, toastCSS);
      navigate("/ErrorPage", {
        state: {
          errorMessage:
            response.error?.message ||
            response?.message ||
            "Something went wrong with flight booking.",
        },
      });
    }
    setPriceDetails(response.data);
    setLoading(false);
    setIsReady(true);
    if (response.data?.Directions) {
      setFlightSegments(response.data.Directions);
    }
    if (response.data?.Directions?.[0]) {
      setDepartureSegments(response.data.Directions[0][0].Segments);
    }

    if (response.data?.Directions?.[1]) {
      setReturnSegments(response.data.Directions[1][0].Segments);
    }

    const newPrice = response.data.TotalPrice;

    setCurrentPrice(newPrice);

    // if (originalPrice !== null && newPrice !== originalPrice) {
    //   const difference = newPrice - originalPrice;
    //   const percentageChange = (
    //     (Math.abs(difference) / originalPrice) *
    //     100
    //   ).toFixed(2);

    //   setPriceDifference(difference);
    //   setPriceChangePercentage(percentageChange);
    //   setPriceChanged(true);

    //   setShowPriceModal(true); // Trigger the modal only if the price has changed
    // }
    if (response.data.IsBaggageChanged) {
      const oldDirections = location.state?.segments || [];
      const newDirections = response.data.Directions || [];

      const changes = [];

      newDirections.forEach((newDirection, dirIndex) => {
        const oldDirection = oldDirections[dirIndex] || [];

        newDirection.forEach((newFlight, segIndex) => {
          const oldFlight = oldDirection[segIndex] || {};

          const newSegments = newFlight.Segments || [];
          const oldSegments = oldFlight.Segments || oldFlight || [];

          newSegments.forEach((newSeg, segSubIdx) => {
            const oldSeg = oldSegments[segSubIdx] || {};

            const newBags = newSeg.Baggage || [];
            const oldBags = oldSeg.Baggage || [];

            newBags.forEach((newBag) => {
              const match = oldBags.find(
                (ob) => ob.PassengerTypeCode === newBag.PassengerTypeCode
              );
              const oldAmount = match?.Amount ?? "N/A";
              const oldUnits = match?.Units ?? "";

              if (
                newBag.Amount !== match?.Amount ||
                newBag.Units !== match?.Units
              ) {
                changes.push(
                  `Check-in: Dir ${dirIndex + 1} Seg ${segIndex + 1} ${newBag.PassengerTypeCode
                  }: ${oldAmount}${oldUnits} → ${newBag.Amount}${newBag.Units}`
                );
              }
            });

            // Carry Baggage
            const newCarry = newSeg.CarryBaggage || [];
            const oldCarry = oldSeg.CarryBaggage || [];

            if (oldCarry.length && !newCarry.length) {
              oldCarry.forEach((oldBag) => {
                changes.push(
                  `Cabin: Dir ${dirIndex + 1} Seg ${segIndex + 1} ${oldBag.PassengerTypeCode
                  }: ${oldBag.Amount}${oldBag.Units} → NONE`
                );
              });
            }

            newCarry.forEach((newBag) => {
              const match = oldCarry.find(
                (ob) => ob.PassengerTypeCode === newBag.PassengerTypeCode
              );
              const oldAmount = match?.Amount ?? "N/A";
              const oldUnits = match?.Units ?? "";
              if (
                newBag.Amount !== match?.Amount ||
                newBag.Units !== match?.Units
              ) {
                changes.push(
                  `Cabin: Dir ${dirIndex + 1} Seg ${segIndex + 1} ${newBag.PassengerTypeCode
                  }: ${oldAmount}${oldUnits} → ${newBag.Amount}${newBag.Units}`
                );
              }
            });
          });
        });
      });

      if (changes.length) {
        toast.info(`✈️ Baggage has been changed.`, { autoClose: 3000 });
      }
    }
  };

  const handleContinueWithNewPrice = () => {
    const token = localStorage.getItem("b2bToken");
    if (!token) {
      navigate("/B2BPortal");
      return;
    }
    setShowPriceModal(false);
    // Proceed with the updated price for the next steps
    navigate("/FlightReservationTwo", {
      state: {
        ItemCodeRef: ItemCodeRef,
        SegmentCodeRefs: SegmentCodeRefs,
        UniqueTransID: UniqueTransID,
        PriceCodeRef: PriceCodeRef,
        Currency: preferredCurrency,
        TotalPrice: convertedTotalPrice,
        segments: location.state?.segments || [],
        routeDetails: location.state?.routeDetails || {},
      },
    });
  };

  localStorage.setItem("DetailflightSearchData", JSON.stringify(priceDetails));

  // Fetch Fare Rules Data
  const handleFareRules = async () => {
    const requestData = { ItemCodeRef, SegmentCodeRefs, UniqueTransID };
    await flightFareRules(requestData, onFareSuccess, onError);
  };
  const handleExtraServices = async () => {
    const requestData = { ItemCodeRef, SegmentCodeRefs, UniqueTransID };
    await flightExtraServices(requestData, onFareSuccess, onError);
  };

  useEffect(() => {
    if (originalPrice && currentPrice) {
      // Ensure conversion before comparison
      const comparePrices = async () => {
        const conversion = await verifyPriceAndConvert();
        if (conversion) {
          const { convertedDifference, convertedPercentage } = conversion;

          // Now, set the price modal based on the converted values
          if (Math.abs(convertedDifference) > 0) {
            setPriceDifference(convertedDifference);
            setPriceChangePercentage(convertedPercentage);
            setPriceChanged(true);
            setShowPriceModal(true);
          }
        }
      };

      comparePrices();
    }
  }, [originalPrice, currentPrice]);
  const verifyPriceAndConvert = async () => {
    try {
      // Convert original price to preferred currency
      const originalConverted = await convertCurrency(
        originalPrice,
        priceDetails?.Currency || "MYR",
        preferredCurrency
      );

      // Convert current price to preferred currency
      const currentConverted = await convertCurrency(
        currentPrice,
        priceDetails?.Currency || "MYR",
        preferredCurrency
      );

      // Calculate difference in preferred currency
      const convertedDifference = currentConverted - originalConverted;
      const convertedPercentage = (
        (Math.abs(convertedDifference) / originalConverted) *
        100
      ).toFixed(2);

      return {
        originalConverted: originalConverted.toFixed(2),
        currentConverted: currentConverted.toFixed(2),
        convertedDifference: convertedDifference.toFixed(2),
        convertedPercentage,
      };
    } catch (error) {
      console.error("Currency conversion error:", error);
      return null;
    }
  };
  useEffect(() => {
    const handleCurrencyChange = (e) => {
      setPreferredCurrency(
        e.detail || localStorage.getItem("preferredCurrency")
      );
    };
    window.addEventListener("currencyChanged", handleCurrencyChange);
    return () => {
      window.removeEventListener("currencyChanged", handleCurrencyChange);
    };
  }, []);

  //  Success Callback for Fare Rules
  const onFareSuccess = (response) => {
    setFareRules(response.data);
  };

  const onError = (error) => {
    console.error("Error fetching price details:", error);
    setLoading(false);
  };

  const direction = priceDetails?.Directions[0][0];
  const segment = direction?.Segments[0];
  const returnSegment = direction?.Segments[1];
  // const baggage = segment?.Baggage[0];
  const bookingInfo = priceDetails?.BookingComponent;
  const passengerFare = priceDetails?.PassengerFares[0];
  const PriceCodeRef = priceDetails?.PriceCodeRef || 0;
  const Currency = priceDetails?.Currency || 0;

  const [convertedBaseFare, setConvertedBaseFare] = useState(baseFare);
  const [convertedTaxes, setConvertedTaxes] = useState(taxes);
  const [convertedDiscountPrice, setConvertedDiscountPrice] = useState(
    discountPrice || 0
  );
  const [convertedServiceCharge, setConvertedServiceCharge] = useState(
    passengerFare?.ServiceCharge || 0
  );
  const [convertedTotalPrice, setConvertedTotalPrice] = useState(totalPrice);
  const [convertedFixedFee, setConvertedFixedFee] = useState(0); // Fixed fee in GBP
  const [convertedMarkup, setConvertedMarkup] = useState(0);
  const [preferredCurrency, setPreferredCurrency] = useState(
    localStorage.getItem("preferredCurrency") || "MYR"
  );
  const [markupSettings, setMarkupSettings] = useState({
    markupTypeListing: "percentage",
    markupValueListing: 0.0001,
    markupTypeBaseFare: "percentage",
    markupValueBaseFare: 0.0001,
    markupTypePassenger: "percentage",
    markupValuePassenger: 0.0001,
    markupTypePassengerBase: "percentage",
    markupValuePassengerBase: 0.0001,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      await getMarkupSettings(
        (response) => {
          const settings = {};
          response.forEach((item) => {
            settings[item.key] = item.value;
          });
          setMarkupSettings({
            markupTypeListing: settings.markupTypeListing || "0",
            markupValueListing:
              parseFloat(settings.markupValueListing) || 0.0001,
            markupTypeBaseFare: settings.markupTypeBaseFare || "fixed",
            markupValueBaseFare:
              parseFloat(settings.markupValueBaseFare) || 0.0001,
            markupTypePassenger: settings.markupTypePassenger || "percentage",
            markupValuePassenger:
              parseFloat(settings.markupValuePassenger) || 0.0001,
            markupTypePassengerBase:
              settings.markupTypePassengerBase || "fixed",
            markupValuePassengerBase:
              parseFloat(settings.markupValuePassengerBase) || 0.0001,
          });
        },
        (error) => {
          console.error("Failed to fetch markup settings", error);
          // Use defaults if API fails
          setMarkupSettings({
            markupTypeListing: "percentage",
            markupValueListing: 0.0001,
            markupTypeBaseFare: "fixed",
            markupValueBaseFare: 0.0001,
            markupTypePassenger: "percentage",
            markupValuePassenger: 0.0001,
            markupTypePassengerBase: "fixed",
            markupValuePassengerBase: 0.0001,
          });
        }
      );
    };

    fetchSettings();
  }, []);
  useEffect(() => {
    const convert = async () => {
      setIsFarePriceReady(false);
      const fromCurrency = priceDetails?.Currency || "MYR";
      const passengerFares = priceDetails?.PassengerFares || [];

      let totalBaseFare = 0.001;
      let totalTaxes = 0.001;

      if (
        passengerFares &&
        Array.isArray(passengerFares) &&
        passengerFares.length > 0
      ) {
        passengerFares.forEach((fare) => {
          totalBaseFare += fare.BasePrice * fare.PassengerCount;
          totalTaxes += fare.Taxes * fare.PassengerCount;
        });
      } else {
        totalBaseFare = baseFare;
        totalTaxes = taxes;
      }

      const convertedBase = await convertCurrency(
        totalBaseFare,
        fromCurrency,
        preferredCurrency
      );
      setConvertedBaseFare(convertedBase.toFixed(2));

      const convertedTax = await convertCurrency(
        totalTaxes,
        fromCurrency,
        preferredCurrency
      );
      setConvertedTaxes(convertedTax.toFixed(2));

      const convertedDiscountAbs = await convertCurrency(
        Math.abs(discountPrice),
        fromCurrency,
        preferredCurrency
      );
      const finalConvertedDiscount = -convertedDiscountAbs;
      setConvertedDiscountPrice(finalConvertedDiscount.toFixed(2));

      const subtotal =
        Number(convertedBase) +
        Number(convertedTax) +
        Number(finalConvertedDiscount);

      const totalPassengerCount =
        passengerCounts.adults +
        passengerCounts.children +
        passengerCounts.infants;

      let markupAmount = 0.001;
      let serviceCharge = 0.001;

      if (totalPassengerCount > 1) {
        if (markupSettings.markupTypePassenger === "percentage") {
          markupAmount = subtotal * (markupSettings.markupValuePassenger / 100);
        } else {
          markupAmount = await convertCurrency(
            markupSettings.markupValuePassenger,
            "GBP",
            preferredCurrency
          );
        }

        if (markupSettings.markupTypePassengerBase === "percentage") {
          serviceCharge =
            subtotal * (markupSettings.markupValuePassengerBase / 100);
        } else {
          serviceCharge = await convertCurrency(
            markupSettings.markupValuePassengerBase,
            "GBP",
            preferredCurrency
          );
        }
      } else {
        if (markupSettings.markupTypeListing === "percentage") {
          markupAmount = subtotal * (markupSettings.markupValueListing / 100);
        } else {
          markupAmount = await convertCurrency(
            markupSettings.markupValueListing,
            "GBP",
            preferredCurrency
          );
        }

        if (markupSettings.markupTypeBaseFare === "percentage") {
          serviceCharge = subtotal * (markupSettings.markupValueBaseFare / 100);
        } else {
          serviceCharge = await convertCurrency(
            markupSettings.markupValueBaseFare,
            "GBP",
            preferredCurrency
          );
        }
      }

      setConvertedMarkup(markupAmount.toFixed(2));
      setConvertedFixedFee(serviceCharge.toFixed(2));

      const finalTotal = subtotal + markupAmount + Number(serviceCharge);

      setConvertedTotalPrice(finalTotal.toFixed(2));
      setIsFarePriceReady(true);
    };

    if (
      (markupSettings.markupValueListing > 0 &&
        markupSettings.markupValueBaseFare > 0) ||
      markupSettings
    ) {
      convert();
    }
  }, [
    baseFare,
    taxes,
    discountPrice,
    passengerFare?.ServiceCharge,
    totalPrice,
    originalPrice,
    currentPrice,
    priceDetails?.Currency,
    preferredCurrency,
    markupSettings,
    passengerCounts,
  ]);
  const applyMarkup = async (subtotal, totalPassengerCount) => {
    let markupAmount = 0;
    let serviceCharge = 0;

    if (totalPassengerCount > 1) {
      // Passenger based markup
      if (markupSettings.markupTypePassenger === "percentage") {
        markupAmount = subtotal * (markupSettings.markupValuePassenger / 100);
      } else {
        markupAmount = await convertCurrency(
          markupSettings.markupValuePassenger,
          "GBP",
          preferredCurrency
        );
      }

      if (markupSettings.markupTypePassengerBase === "percentage") {
        serviceCharge =
          subtotal * (markupSettings.markupValuePassengerBase / 100);
      } else {
        serviceCharge = await convertCurrency(
          markupSettings.markupValuePassengerBase,
          "GBP",
          preferredCurrency
        );
      }
    } else {
      // Listing based markup
      if (markupSettings.markupTypeListing === "percentage") {
        markupAmount = subtotal * (markupSettings.markupValueListing / 100);
      } else {
        markupAmount = await convertCurrency(
          markupSettings.markupValueListing,
          "GBP",
          preferredCurrency
        );
      }

      if (markupSettings.markupTypeBaseFare === "percentage") {
        serviceCharge = subtotal * (markupSettings.markupValueBaseFare / 100);
      } else {
        serviceCharge = await convertCurrency(
          markupSettings.markupValueBaseFare,
          "GBP",
          preferredCurrency
        );
      }
    }

    return {
      markupAmount,
      serviceCharge,
      finalTotal: subtotal + markupAmount + serviceCharge,
    };
  };
  useEffect(() => {
    const convertPricesWithMarkup = async () => {
      if (!originalPrice || !currentPrice || !priceDetails) return;

      const fromCurrency = "MYR"; // priceCheck API currency
      const paxCount =
        passengerCounts.adults +
        passengerCounts.children +
        passengerCounts.infants;

      // Convert raw prices
      const originalConverted = await convertCurrency(
        originalPrice,
        fromCurrency,
        preferredCurrency
      );

      const currentConverted = await convertCurrency(
        currentPrice,
        fromCurrency,
        preferredCurrency
      );

      // Apply markup on BOTH
      const originalWithMarkup = await applyMarkup(
        Number(originalConverted),
        paxCount
      );

      const currentWithMarkup = await applyMarkup(
        Number(currentConverted),
        paxCount
      );

      setConvertedOriginalPrice(originalWithMarkup.finalTotal);
      setConvertedCurrentPrice(currentWithMarkup.finalTotal);

      const diff = currentWithMarkup.finalTotal - originalWithMarkup.finalTotal;

      const percent = (Math.abs(diff) / originalWithMarkup.finalTotal) * 100;

      if (diff !== 0) {
        setPriceDifference(diff.toFixed(2));
        setPriceChangePercentage(percent.toFixed(2));
        setPriceChanged(true);
        setShowPriceModal(true);
      }
    };

    convertPricesWithMarkup();
  }, [
    originalPrice,
    currentPrice,
    preferredCurrency,
    markupSettings,
    passengerCounts,
  ]);

  useEffect(() => {
    const convertFares = async () => {
      if (!priceDetails?.PassengerFares || !preferredCurrency) return;

      const fromCurrency = priceDetails.Currency || "MYR";

      const converted = await Promise.all(
        priceDetails.PassengerFares.map(async (detail) => {
          const base = await convertCurrency(
            detail.BasePrice,
            fromCurrency,
            preferredCurrency
          );
          const total = base * detail.PassengerCount;

          return {
            ...detail,
            convertedBase: parseFloat(base.toFixed(2)),
            convertedTotal: parseFloat(total.toFixed(2)),
          };
        })
      );

      setConvertedPassengerFares(converted);
    };

    convertFares();
  }, [priceDetails, preferredCurrency]);
  if (!isReady || loading) {
    return (
      <div className="loaderWrap">
        <div className="loader">
          <div className="rocket"></div>
        </div>
        <h3>Loading Flight Details...</h3>
      </div>
    );
  }
  // const finalCurrentPrice = parseFloat(convertedCurrentPrice) * 1.07 + parseFloat(convertedFixedFee);
  const finalCurrentPrice =
    totalPassengerCount > 1
      ? parseFloat(convertedCurrentPrice) *
      (1 + markupSettings.markupValuePassenger / 100) +
      parseFloat(convertedFixedFee)
      : markupSettings.markupTypeListing === "percentage"
        ? parseFloat(convertedCurrentPrice) *
        (1 + markupSettings.markupValueListing / 100) +
        parseFloat(convertedFixedFee)
        : parseFloat(convertedCurrentPrice) + parseFloat(convertedFixedFee);

  const finalOriginalPrice = parseFloat(convertedOriginalPrice);

  const difference = convertedTotalPrice - convertedOriginalPrice;
  const absDifference = Math.abs(difference);

  const percentChange = (difference / convertedOriginalPrice) * 100;
  const absPercentChange = Math.abs(percentChange);

  const isIncrease = difference > 0;
  const changeText = isIncrease ? "Increased" : "Decreased";
  const sign = isIncrease ? "+" : "-";

  const firstSegment = direction?.Segments[0];
  const lastSegment = direction?.Segments[direction.Segments.length - 1];
  const departureTime = new Date(firstSegment?.Departure);
  const arrivalTime = new Date(lastSegment?.Arrival);
  const totalTimeMs = arrivalTime - departureTime;
  const totalHours = Math.floor(totalTimeMs / (1000 * 60 * 60));
  const totalMinutes = Math.floor(
    (totalTimeMs % (1000 * 60 * 60)) / (1000 * 60)
  );
  const flights = location.state?.flights || []; // Get flight data

  const parseDurationToMs = (duration) => {
    if (!duration) return 0;

    const match = duration.match(/(\d+)h\s*(\d*)m?/);
    if (!match) return 0;

    const hours = parseInt(match[1]) || 0;
    const minutes = parseInt(match[2]) || 0;
    return hours * 60 * 60 * 1000 + minutes * 60 * 1000;
  };

  const formatMsToDuration = (ms) => {
    const totalMinutes = Math.floor(ms / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  };

  const calculateTotalTravelTime = (segments, layovers) => {
    if (!segments || segments.length === 0) return "0h 0m";

    const totalFlightTime = segments.reduce((total, segment) => {
      const segmentDuration =
        segment.Duration?.[0] ||
        `${Math.floor(
          (new Date(segment.Arrival) - new Date(segment.Departure)) /
          (1000 * 60 * 60)
        )}h 
                             ${Math.floor(
          ((new Date(segment.Arrival) -
            new Date(segment.Departure)) %
            (1000 * 60 * 60)) /
          (1000 * 60)
        )}m`;
      return total + parseDurationToMs(segmentDuration);
    }, 0);

    const totalLayoverTime = Array.isArray(layovers)
      ? layovers.reduce(
        (total, layover) => total + parseDurationToMs(layover),
        0
      )
      : parseDurationToMs(layovers);

    const totalTime = totalFlightTime + totalLayoverTime;
    return formatMsToDuration(totalTime);
  };
  const closePriceModal = () => {
    setShowPriceModal(false);
    setPriceChanged(false);
  };

  return (
    <>
      <Header></Header>
      <div className="mainContent depReturnFlightWrap">
        <div className="flightProgressWrap">
          <div className="flightProgressInner">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-6">
                  <ul>
                    <li>
                      <div className="itemWrap active">
                        <div className="noWrap">
                          <h2>1</h2>
                          <p>Review Selection</p>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap">
                        <div className="noWrap">
                          <h2>2</h2>
                          <p> Enter Details </p>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap">
                        <div className="noWrap">
                          <h2>3</h2>
                          <p>Make Payment </p>
                        </div>
                        <div className="dataWrap"></div>
                      </div>
                    </li>
                    <li>
                      <div className="itemWrap">
                        <div className="noWrap">
                          <h2>4</h2>
                          <p>Booking Confirmation</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flightReservWrap flightReservDepr">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-9">
                <div className="leftPannelWrap">
                  <div className="row">
                    <div className="col-md-12">
                      <ul className="depRetList">
                        <li>
                          <div className="itemWrap">
                            <p>Departure</p>
                            <div className="midData">
                              <div className="icoWrap">
                                <img
                                  src={PlaneIco1}
                                  className="img-fluid"
                                  alt="Plane"
                                />
                              </div>
                              <div className="dataWrap">
                                <div className="routeWrapper">
                                  <h2>
                                    {getCityByIata(finalDepartureInfo?.origin)}{" "}
                                    ({finalDepartureInfo?.origin})
                                  </h2>

                                  <div className="routeSeparator">
                                    {departureSegments.length === 1 ? (
                                      <img
                                        src={PlaneIco}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    ) : (
                                      departureSegments.map(
                                        (segment, index) => {
                                          const nextSegment =
                                            departureSegments[index + 1];
                                          if (!nextSegment) return null;

                                          const layoverDuration =
                                            calculateLayoverTime(
                                              segment.Arrival,
                                              nextSegment.Departure
                                            );

                                          return (
                                            <div
                                              key={index}
                                              className="layoverWrap"
                                            >
                                              <div className="dotWrap">
                                                <img
                                                  src={StopPlaneImg}
                                                  className="img-fluid"
                                                  alt="Layover Dot"
                                                />
                                              </div>
                                              <div className="layoverData">
                                                <h3>
                                                  {getCityByIata(
                                                    segment.Destination
                                                  )}{" "}
                                                  ({segment.Destination})
                                                </h3>
                                                <p>
                                                  Layover: {layoverDuration}
                                                </p>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    )}
                                  </div>

                                  <h2>
                                    {getCityByIata(
                                      finalDepartureInfo?.destination
                                    )}{" "}
                                    ({finalDepartureInfo?.destination})
                                  </h2>
                                </div>

                                <h6>
                                  {new Date(
                                    finalDepartureInfo?.date
                                  ).toLocaleDateString("en-US", {
                                    weekday: "long",
                                    day: "numeric",
                                    month: "short",
                                  })}
                                  <span>
                                    {" "}
                                    {departureSegments.length - 1 === 0
                                      ? "Non-stop"
                                      : `${departureSegments.length - 1
                                      } stop(s)`}
                                  </span>
                                  {calculateTotalTravelTime(
                                    departureSegments,
                                    departureLayovers
                                  )}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/*  Taxes Div For mobile */}
                  <div className="row forMobDisRow">
                    <div className="col-md-12">
                      <div className="rightResPannelWrap">
                        <div className="itemWraps martTop">
                          <div className="itemPriceWrap">
                            <h2>Prices</h2>
                            <div className="ctaWrap">
                              <button
                                className={`btn ${seatClass === "Economy" ? "active" : ""
                                  }`}
                              >
                                Economy
                              </button>
                              <button
                                className={`btn ${seatClass === "Business" ? "active" : ""
                                  }`}
                              >
                                Business
                              </button>
                              <button
                                className={`btn ${seatClass === "First" ? "active" : ""
                                  }`}
                              >
                                First Class
                              </button>
                              <button
                                className={`btn ${seatClass === "Premium Economy"
                                    ? "active"
                                    : ""
                                  }`}
                              >
                                Premium Economy
                              </button>
                            </div>
                          </div>
                          <div className="itemWrap fareSumWrap">
                            <h2>Fare Summary</h2>
                            <p>{passengerFare?.PassengerCount} Travellers</p>
                            <div
                              className="accordion"
                              id="accordionFlushExample"
                            >
                              <div className="accordion-item">
                                <h2 className="accordion-header">
                                  <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseOne"
                                    aria-expanded="true"
                                    aria-controls="flush-collapseOne"
                                  >
                                    <h3>
                                      <img
                                        src={downArrowIco}
                                        className="img-fluid"
                                        alt=""
                                      />
                                      Base fare
                                    </h3>
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseOne"
                                  className="accordion-collapse collapse show"
                                >
                                  <div className="accordion-body">
                                    <ul>
                                      {convertedPassengerFares.map(
                                        (detail, index) => {
                                          const typeMap = {
                                            ADT: "Adult",
                                            CHD: "Child",
                                            CNN: "Child",
                                            INF: "Infant",
                                          };
                                          const label =
                                            typeMap[detail.PassengerType] ||
                                            detail.PassengerType;
                                          return (
                                            <li key={index}>
                                              <p>
                                                {detail.PassengerCount} x{" "}
                                                {label} (
                                                {!isFarePriceReady
                                                  ? "Loading…"
                                                  : `${preferredCurrency} ${Math.round(
                                                    detail.convertedBase
                                                  ).toFixed(2)}`}
                                                )
                                              </p>
                                              <p>
                                                {!isFarePriceReady
                                                  ? "Loading…"
                                                  : `${preferredCurrency} ${Math.round(
                                                    detail.convertedTotal
                                                  ).toFixed(2)}`}
                                              </p>
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  </div>
                                  <div className="accordion-body">
                                    <ul>
                                      <li>
                                        <p>DiscountPrice</p>
                                        <p>
                                          {/* {preferredCurrency} {convertedDiscountPrice} */}
                                          {!isFarePriceReady
                                            ? "Loading…"
                                            : `${preferredCurrency} ${Math.round(
                                              convertedDiscountPrice
                                            ).toFixed(2)}`}
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="accordion-item">
                                <h2 className="accordion-header">
                                  <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseTwo"
                                    aria-expanded="true"
                                    aria-controls="flush-collapseTwo"
                                  >
                                    <h3>
                                      <img
                                        src={downArrowIco}
                                        className="img-fluid"
                                        alt=""
                                      />
                                      Taxes, Fee and Surcharges
                                    </h3>
                                    <h3>
                                      {/* {preferredCurrency} {(parseFloat(convertedTaxes) + parseFloat(convertedMarkup)).toFixed(2)} */}
                                      {!isFarePriceReady
                                        ? "Loading…"
                                        : `${preferredCurrency} ${(
                                          Math.round(convertedTaxes) +
                                          Math.round(convertedMarkup)
                                        ).toFixed(2)}`}
                                    </h3>
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseTwo"
                                  className="accordion-collapse collapse show"
                                ></div>
                              </div>
                              <div className="accordion-item">
                                <h2 className="accordion-header">
                                  <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#flush-collapseThree"
                                    aria-expanded="true"
                                    aria-controls="flush-collapseThree"
                                  >
                                    <h3>
                                      <img
                                        src={downArrowIco}
                                        className="img-fluid"
                                        alt=""
                                      />
                                      Other Services
                                    </h3>
                                  </button>
                                </h2>
                                <div
                                  id="flush-collapseThree"
                                  className="accordion-collapse collapse show"
                                >
                                  <div className="accordion-body">
                                    <ul>
                                      <li>
                                        <p>Service Charge</p>
                                        <p>
                                          {/* {preferredCurrency} {parseFloat(convertedFixedFee).toFixed(2)} */}
                                          {!isFarePriceReady
                                            ? "Loading…"
                                            : `${preferredCurrency} ${Math.round(
                                              convertedFixedFee
                                            ).toFixed(2)}`}
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="btmTtlWrap">
                              <h2>Total Amount</h2>

                              {/* {preferredCurrency} {convertedTotalPrice} */}
                              {!isFarePriceReady
                                ? "Loading…"
                                : `${preferredCurrency} ${Math.round(
                                  convertedTotalPrice
                                ).toFixed(2)}`}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="digitalTicketWrap flightReservSumWrap">
                        <div className="ticketBox">
                          <div className="leftWraps">
                            <div className="topTTl">
                              <h2>Departure Summary</h2>
                            </div>

                            {departureSegments.map((segment, index) => (
                              <div
                                key={`dep-${index}`}
                                className={`flightReservBgBlue${index === departureSegments.length - 1
                                    ? " last"
                                    : ""
                                  }`}
                              >
                                {/* Top Info */}
                                <div className="topTtlWrap">
                                  <div className="title">
                                    <div className="icoWrap">
                                      <img
                                        src={getAirlineLogoUrl(
                                          segment.AirlineCode
                                        )}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </div>
                                    <h2>
                                      {segment.Airline} - Flight{" "}
                                      {segment.FlightNumber}
                                    </h2>
                                  </div>
                                  <h6 className="note">
                                    {priceDetails?.Refundable
                                      ? "Refundable"
                                      : "Non-Refundable"}
                                  </h6>
                                  <p className="classTxt">
                                    Travel Class:{" "}
                                    <span>{segment.ServiceClass}</span>
                                  </p>
                                </div>

                                {/* Segment Details */}
                                <div className="trvelTicWrap">
                                  <div className="leftWrap">
                                    <ul>
                                      <li>
                                        <div className="items mainItem">
                                          <div className="leftData">
                                            <h3>{segment.Origin}</h3>
                                            <h5>
                                              {segment.Departure.split(
                                                " "
                                              )[1].slice(0, 5)}
                                            </h5>
                                          </div>
                                          <div className="rightData">
                                            <p>
                                              {formatDateWithWeekday(
                                                segment.Departure
                                              )}
                                            </p>
                                            <p>
                                              {getCityByIata(segment.Origin)}
                                            </p>
                                            <p>
                                              {(segment.Details[0]
                                                ?.OriginTerminal &&
                                                "Terminal - " +
                                                segment.Details[0]
                                                  ?.OriginTerminal) ||
                                                "Terminal not specified"}
                                            </p>
                                          </div>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="items">
                                          <h4>
                                            {segment.Details[0]?.FlightTime}
                                          </h4>
                                          <div className="planeIcoWrap">
                                            <img
                                              src={PlaneIco}
                                              className="img-fluid"
                                              alt=""
                                            />
                                            {index <
                                              departureSegments.length - 1 && (
                                                <div className="stopIndicator">
                                                  <div className="stopDot"></div>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      </li>

                                      <li>
                                        <div className="items mainItem">
                                          <div className="leftData">
                                            <h3>{segment.Destination}</h3>
                                            <h5>
                                              {segment.Arrival.split(
                                                " "
                                              )[1].slice(0, 5)}
                                            </h5>
                                          </div>
                                          <div className="rightData">
                                            <p>
                                              {formatDateWithWeekday(
                                                segment.Arrival
                                              )}
                                            </p>
                                            <p>
                                              {getCityByIata(
                                                segment.Destination
                                              )}
                                            </p>
                                            <p>
                                              {(segment.Details[0]
                                                ?.DestinationTerminal &&
                                                "Terminal - " +
                                                segment.Details[0]
                                                  ?.DestinationTerminal) ||
                                                "Terminal not specified"}
                                            </p>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>

                                  <div className="rightWrap">
                                    <ul>
                                      <li>
                                        <p>Check-in Baggage</p>
                                        {segment.Baggage?.map((bag, i) => {
                                          const typeMap = {
                                            ADT: "Adult",
                                            CHD: "Child",
                                            CNN: "Child",
                                            INF: "Infant",
                                          };
                                          const passengerType =
                                            typeMap[bag.PassengerTypeCode] ||
                                            bag.PassengerTypeCode;

                                          const formatBaggage = (
                                            bag,
                                            passengerType
                                          ) => {
                                            if (!bag) {
                                              // if (passengerType === "Child") return "Same as Adult";
                                              return "None";
                                            }

                                            let amount = bag.Amount;
                                            let unit = bag.Units?.toLowerCase();
                                            const serviceClass = (
                                              segment?.ServiceClass || ""
                                            ).toLowerCase();

                                            if (passengerType === "Infant") {
                                              if (
                                                unit?.includes("kg") ||
                                                unit?.includes("kilo")
                                              )
                                                return `${amount} kgs`;
                                              if (
                                                unit?.includes("piece") ||
                                                unit?.includes("pc")
                                              ) {
                                                return `${amount * 10
                                                  }kgs (${amount} Piece*10kgs)`;
                                              }
                                              return `${amount} ${bag.Units}`;
                                            }

                                            if (
                                              unit?.includes("kg") ||
                                              unit?.includes("kilo")
                                            ) {
                                              return `${amount} kgs`;
                                            }

                                            if (
                                              unit?.includes("piece") ||
                                              unit?.includes("pc")
                                            ) {
                                              if (
                                                serviceClass.includes(
                                                  "econom"
                                                ) ||
                                                serviceClass.includes("Econom")
                                              ) {
                                                return `${amount * 23
                                                  } kgs (${amount} Piece*23kgs)`;
                                              } else {
                                                return `${amount * 32
                                                  } kgs (${amount} Piece*32kgs)`;
                                              }
                                            }

                                            return `${amount} ${bag.Units}`;
                                          };

                                          return (
                                            <h3 key={i}>
                                              {passengerType}{" "}
                                              <span>
                                                (
                                                {formatBaggage(
                                                  bag,
                                                  passengerType
                                                )}
                                                )
                                              </span>
                                            </h3>
                                          );
                                        })}
                                      </li>

                                      <li>
                                        <p>Cabin Baggage</p>
                                        {segment.CarryBaggage?.map((bag, i) => {
                                          const typeMap = {
                                            ADT: "Adult",
                                            CHD: "Child",
                                            CNN: "Child",
                                            INF: "Infant",
                                          };
                                          const passengerType =
                                            typeMap[bag.PassengerTypeCode] ||
                                            bag.PassengerTypeCode;

                                          const formatCabin = (bag) => {
                                            if (!bag) return "--";
                                            let amount = bag.Amount;
                                            let unit = bag.Units?.toLowerCase();

                                            if (
                                              unit?.includes("kg") ||
                                              unit?.includes("kilo")
                                            )
                                              return `${amount} kgs`;
                                            if (
                                              unit?.includes("piece") ||
                                              unit?.includes("pc")
                                            )
                                              return `${amount} Piece(s)`;
                                            return `${amount} ${bag.Units}`;
                                          };

                                          return (
                                            <h3 key={`cabin-${i}`}>
                                              {passengerType}{" "}
                                              <span>({formatCabin(bag)})</span>
                                            </h3>
                                          );
                                        })}
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                {/* Layover (if not last segment) */}
                                {index < departureSegments.length - 1 && (
                                  <div className="ticketinfoWrap layover-info">
                                    <ul>
                                      <li>
                                        <img
                                          src={layoverImages[index]}
                                          alt={`Layover ${index + 1}`}
                                          className="img-fluid"
                                        />
                                        <p>
                                          Layover at{" "}
                                          {getCityByIata(segment.Destination)} (
                                          {segment.Destination}) - Duration:{" "}
                                          {calculateLayoverTime(
                                            segment.Arrival,
                                            departureSegments[index + 1]
                                              .Departure
                                          )}
                                          {segment.Details?.[0]
                                            ?.DestinationTerminal &&
                                            `, Terminal: ${segment.Details[0].DestinationTerminal}`}
                                        </p>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                            ))}

                            <div className="btmNote">
                              <img
                                src={Traveler}
                                className="img-fluid"
                                alt=""
                              />
                              <p>
                                Sorry, extra check-in baggage allowance details
                                are not available currently from airline.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <ul className="depRetList">
                            {returnSegments.length > 0 && (
                              <li>
                                <div className="itemWrap">
                                  <p>Return</p>
                                  <div className="midData">
                                    <div className="icoWrap">
                                      <img
                                        src={PlaneIco2}
                                        className="img-fluid"
                                        alt="Plane"
                                      />
                                    </div>
                                    <div className="dataWrap">
                                      <div className="routeWrapper">
                                        <h2>
                                          {getCityByIata(returnInfo?.origin)} (
                                          {returnInfo?.origin})
                                        </h2>

                                        <div className="routeSeparator">
                                          {returnSegments.length === 1 ? (
                                            <img
                                              src={PlaneIco}
                                              className="img-fluid"
                                              alt=""
                                            />
                                          ) : (
                                            returnSegments.map(
                                              (segment, index) => {
                                                const nextSegment =
                                                  returnSegments[index + 1];
                                                if (!nextSegment) return null;

                                                const layoverDuration =
                                                  calculateLayoverTime(
                                                    segment.Arrival,
                                                    nextSegment.Departure
                                                  );

                                                return (
                                                  <div
                                                    key={index}
                                                    className="layoverWrap"
                                                  >
                                                    <div className="dotWrap">
                                                      <img
                                                        src={StopPlaneImg}
                                                        className="img-fluid"
                                                        alt="Layover Dot"
                                                      />
                                                    </div>
                                                    <div className="layoverData">
                                                      <h3>
                                                        {getCityByIata(
                                                          segment.Destination
                                                        )}{" "}
                                                        ({segment.Destination})
                                                      </h3>
                                                      <p>
                                                        Layover:{" "}
                                                        {layoverDuration}
                                                      </p>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )
                                          )}
                                        </div>

                                        <h2>
                                          {getCityByIata(
                                            returnInfo?.destination
                                          )}{" "}
                                          ({returnInfo?.destination})
                                        </h2>
                                      </div>

                                      <h6>
                                        {new Date(
                                          returnInfo?.date
                                        ).toLocaleDateString("en-US", {
                                          weekday: "long",
                                          day: "numeric",
                                          month: "short",
                                        })}
                                        <span>
                                          {" "}
                                          {returnSegments.length - 1 === 0
                                            ? "Non-stop"
                                            : `${returnSegments.length - 1
                                            } stop(s)`}
                                        </span>
                                        {calculateTotalTravelTime(
                                          returnSegments,
                                          returnLayovers
                                        )}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                      {isRoundTrip && returnSegments.length > 0 && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="digitalTicketWrap flightReservSumWrap">
                              <div className="ticketBox">
                                <div className="leftWraps">
                                  <div className="topTTl">
                                    <h2>Return Summary</h2>
                                  </div>

                                  {returnSegments.map((segment, index) => (
                                    <div
                                      key={`ret-${index}`}
                                      className={`flightReservBgBlue${index === returnSegments.length - 1
                                          ? " last"
                                          : ""
                                        }`}
                                    >
                                      <div className="topTtlWrap">
                                        <div className="title">
                                          <div className="icoWrap">
                                            <img
                                              src={getAirlineLogoUrl(
                                                segment.AirlineCode
                                              )}
                                              className="img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <h2>
                                            {segment.Airline} - Flight{" "}
                                            {segment.FlightNumber}
                                          </h2>
                                        </div>
                                        <h6 className="note">
                                          {priceDetails?.Refundable
                                            ? "Refundable"
                                            : "Non-Refundable"}
                                        </h6>
                                        <p className="classTxt">
                                          Travel Class:{" "}
                                          <span>{segment.ServiceClass}</span>
                                        </p>
                                      </div>

                                      <div className="trvelTicWrap">
                                        <div className="leftWrap">
                                          <ul>
                                            <li>
                                              <div className="items mainItem">
                                                <div className="leftData">
                                                  <h3>{segment.Origin}</h3>
                                                  <h5>
                                                    {segment.Departure.split(
                                                      " "
                                                    )[1].slice(0, 5)}
                                                  </h5>
                                                </div>
                                                <div className="rightData">
                                                  <p>
                                                    {formatDateWithWeekday(
                                                      segment.Departure
                                                    )}
                                                  </p>
                                                  <p>
                                                    {getCityByIata(
                                                      segment.Origin
                                                    )}
                                                  </p>
                                                  <p>
                                                    {(segment.Details[0]
                                                      ?.OriginTerminal &&
                                                      "Terminal - " +
                                                      segment.Details[0]
                                                        .OriginTerminal) ||
                                                      "Terminal not specified"}
                                                  </p>
                                                </div>
                                              </div>
                                            </li>

                                            <li>
                                              <div className="items">
                                                <h4>
                                                  {
                                                    segment.Details[0]
                                                      ?.FlightTime
                                                  }
                                                </h4>
                                                <div className="planeIcoWrap">
                                                  <img
                                                    src={PlaneIco}
                                                    className="img-fluid"
                                                    alt=""
                                                  />
                                                  {index <
                                                    returnSegments.length -
                                                    1 && (
                                                      <div className="stopIndicator">
                                                        <div className="stopDot"></div>
                                                      </div>
                                                    )}
                                                </div>
                                              </div>
                                            </li>

                                            <li>
                                              <div className="items mainItem">
                                                <div className="leftData">
                                                  <h3>{segment.Destination}</h3>
                                                  <h5>
                                                    {segment.Arrival.split(
                                                      " "
                                                    )[1].slice(0, 5)}
                                                  </h5>
                                                </div>
                                                <div className="rightData">
                                                  <p>
                                                    {formatDateWithWeekday(
                                                      segment.Arrival
                                                    )}
                                                  </p>
                                                  <p>
                                                    {getCityByIata(
                                                      segment.Destination
                                                    )}
                                                  </p>
                                                  <p>
                                                    {(segment.Details[0]
                                                      ?.DestinationTerminal &&
                                                      "Terminal - " +
                                                      segment.Details[0]
                                                        .DestinationTerminal) ||
                                                      "Terminal not specified"}
                                                  </p>
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>

                                        <div className="rightWrap">
                                          <ul>
                                            <li>
                                              <p>Check-in Baggage</p>
                                              {segment.Baggage?.map(
                                                (bag, i) => {
                                                  const typeMap = {
                                                    ADT: "Adult",
                                                    CHD: "Child",
                                                    CNN: "Child",
                                                    INF: "Infant",
                                                  };
                                                  const passengerType =
                                                    typeMap[
                                                    bag.PassengerTypeCode
                                                    ] || bag.PassengerTypeCode;

                                                  const formatBaggage = (
                                                    bag,
                                                    passengerType
                                                  ) => {
                                                    if (!bag) {
                                                      // if (passengerType === "Child") return "Same as Adult";
                                                      return "None";
                                                    }

                                                    let amount = bag.Amount;
                                                    let unit =
                                                      bag.Units?.toLowerCase();
                                                    const serviceClass = (
                                                      segment?.ServiceClass ||
                                                      ""
                                                    ).toLowerCase();

                                                    if (
                                                      passengerType === "Infant"
                                                    ) {
                                                      if (
                                                        unit?.includes("kg") ||
                                                        unit?.includes("kilo")
                                                      )
                                                        return `${amount} kgs`;
                                                      if (
                                                        unit?.includes(
                                                          "piece"
                                                        ) ||
                                                        unit?.includes("pc")
                                                      ) {
                                                        return `${amount * 10
                                                          }kgs (${amount} Piece*10kgs)`;
                                                      }
                                                      return `${amount} ${bag.Units}`;
                                                    }

                                                    if (
                                                      unit?.includes("kg") ||
                                                      unit?.includes("kilo")
                                                    ) {
                                                      return `${amount} kgs`;
                                                    }

                                                    if (
                                                      unit?.includes("piece") ||
                                                      unit?.includes("pc")
                                                    ) {
                                                      if (
                                                        serviceClass.includes(
                                                          "econom"
                                                        ) ||
                                                        serviceClass.includes(
                                                          "Econom"
                                                        )
                                                      ) {
                                                        return `${amount * 23
                                                          } kgs (${amount} Piece*23kgs)`;
                                                      } else {
                                                        return `${amount * 32
                                                          } kgs (${amount} Piece*32kgs)`;
                                                      }
                                                    }

                                                    return `${amount} ${bag.Units}`;
                                                  };

                                                  return (
                                                    <h3 key={i}>
                                                      {passengerType}{" "}
                                                      <span>
                                                        (
                                                        {formatBaggage(
                                                          bag,
                                                          passengerType
                                                        )}
                                                        )
                                                      </span>
                                                    </h3>
                                                  );
                                                }
                                              )}
                                            </li>

                                            <li>
                                              <p>Cabin Baggage</p>
                                              {segment.CarryBaggage?.map(
                                                (bag, i) => {
                                                  const typeMap = {
                                                    ADT: "Adult",
                                                    CHD: "Child",
                                                    CNN: "Child",
                                                    INF: "Infant",
                                                  };
                                                  const passengerType =
                                                    typeMap[
                                                    bag.PassengerTypeCode
                                                    ] || bag.PassengerTypeCode;

                                                  const formatCabin = (bag) => {
                                                    if (!bag) return "--";
                                                    let amount = bag.Amount;
                                                    let unit =
                                                      bag.Units?.toLowerCase();

                                                    if (
                                                      unit?.includes("kg") ||
                                                      unit?.includes("kilo")
                                                    )
                                                      return `${amount} kgs`;
                                                    if (
                                                      unit?.includes("piece") ||
                                                      unit?.includes("pc")
                                                    )
                                                      return `${amount} Piece(s)`;
                                                    return `${amount} ${bag.Units}`;
                                                  };

                                                  return (
                                                    <h3 key={`cabin-${i}`}>
                                                      {passengerType}{" "}
                                                      <span>
                                                        ({formatCabin(bag)})
                                                      </span>
                                                    </h3>
                                                  );
                                                }
                                              )}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>

                                      {/* Layover section if not last segment */}
                                      {index < returnSegments.length - 1 && (
                                        <div className="ticketinfoWrap layover-info">
                                          <ul>
                                            <li>
                                              <img
                                                src={layoverImages[index]}
                                                alt={`Layover ${index + 1}`}
                                                className="img-fluid"
                                              />
                                              <p>
                                                Layover at{" "}
                                                {getCityByIata(
                                                  segment.Destination
                                                )}{" "}
                                                ({segment.Destination}) -
                                                Duration:{" "}
                                                {calculateLayoverTime(
                                                  segment.Arrival,
                                                  returnSegments[index + 1]
                                                    ?.Departure
                                                )}
                                                {segment.Details?.[0]
                                                  ?.DestinationTerminal &&
                                                  `, Terminal: ${segment.Details[0].DestinationTerminal}`}
                                              </p>
                                            </li>
                                          </ul>
                                        </div>
                                      )}
                                    </div>
                                  ))}

                                  <div className="btmNote">
                                    <img
                                      src={Traveler}
                                      className="img-fluid"
                                      alt=""
                                    />
                                    <p>
                                      Sorry, extra check-in baggage allowance
                                      details are not available currently from
                                      airline.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="accordion flightReservSumAccWrap"
                        id="accordionExample"
                      >
                        {/* Important Guidelines */}
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className={`accordion-button ${isOpen.section1 ? "" : "collapsed"
                                }`}
                              type="button"
                              onClick={() => toggleAccordion("section1")}
                              aria-expanded={isOpen.section1}
                              aria-controls="collapseOne"
                            >
                              Important Guidelines
                            </button>
                          </h2>
                          <div
                            id="collapseOne"
                            className={`accordion-collapse collapse ${isOpen.section1 ? "show" : ""
                              }`}
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <p>
                                When booking a flight, it is important for
                                passengers to follow certain guidelines to
                                ensure a smooth and stress-free experience. Here
                                are some important guidelines for passengers to
                                observe when booking a flight:
                              </p>
                              <p>
                                1. Double-Check Travel Details: Before
                                confirming your booking, carefully review all
                                travel details, including dates, destinations,
                                and passenger information. Ensure that the
                                information entered is accurate to avoid any
                                complications later on.
                              </p>
                              {/* <a href="#">Read more</a> */}
                            </div>
                          </div>
                        </div>

                        {/* Cancellation/Refund Policy */}
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className={`accordion-button ${isOpen.section2 ? "" : "collapsed"
                                }`}
                              type="button"
                              onClick={() => toggleAccordion("section2")}
                              aria-expanded={isOpen.section2}
                              aria-controls="collapseTwo"
                            >
                              Cancellation/Refund Policy
                            </button>
                          </h2>
                          <div
                            id="collapseTwo"
                            className={`accordion-collapse collapse ${isOpen.section2 ? "show" : ""
                              }`}
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <p>
                                At <b>Travasco</b>, we aim to provide a smooth
                                and reliable travel booking experience. However,
                                we understand that unforeseen circumstances may
                                lead to changes in your travel plans. This
                                Flight Cancellation Policy outlines the
                                conditions under which cancellations are handled
                                for flights booked through our platform, in
                                compliance with UK and EU regulations.
                              </p>
                              {/* <h4>Cancellation Charges</h4> */}
                              <a href="/CancellationPolicy">Read more</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="rightResPannelWrap mobRightPannelWrap">
                  <div className="itemWraps forMobDisNone">
                    <div className="itemPriceWrap">
                      <h2>Prices</h2>
                      <div className="ctaWrap">
                        <button
                          className={`btn ${seatClass === "Economy" ? "active" : ""
                            }`}
                        >
                          Economy
                        </button>
                        <button
                          className={`btn ${seatClass === "Business" ? "active" : ""
                            }`}
                        >
                          Business
                        </button>
                        <button
                          className={`btn ${seatClass === "First" ? "active" : ""
                            }`}
                        >
                          First Class
                        </button>
                        <button
                          className={`btn ${seatClass === "Premium Economy" ? "active" : ""
                            }`}
                        >
                          Premium Economy
                        </button>
                      </div>
                    </div>
                    <div className="itemWrap fareSumWrap">
                      <div className="topFareTTlWrap">
                        <h2>Fare Summary</h2>
                        <p>{passengerFare?.PassengerCount} Travellers</p>
                      </div>
                      <div className="accordion" id="accordionFlushExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseOne"
                              aria-expanded="true"
                              aria-controls="flush-collapseOne"
                            >
                              <h3>
                                <img
                                  src={downArrowIco}
                                  className="img-fluid"
                                  alt=""
                                />
                                Base fare
                              </h3>
                            </button>
                          </h2>
                          <div
                            id="flush-collapseOne"
                            className="accordion-collapse collapse show"
                          >
                            <div className="accordion-body">
                              <ul>
                                {convertedPassengerFares.map(
                                  (detail, index) => {
                                    const typeMap = {
                                      ADT: "Adult",
                                      CHD: "Child",
                                      CNN: "Child",
                                      INF: "Infant",
                                    };
                                    const label =
                                      typeMap[detail.PassengerType] ||
                                      detail.PassengerType;
                                    return (
                                      <li key={index}>
                                        <p>
                                          {detail.PassengerCount} x {label} (
                                          {/* {preferredCurrency}{" "}
                                          {detail.convertedBase.toFixed(2)}) */}
                                          {!isFarePriceReady
                                            ? "Loading…"
                                            : `${preferredCurrency} ${Math.round(
                                              detail.convertedBase
                                            ).toFixed(2)}`}
                                          )
                                        </p>
                                        <p>
                                          {/* {preferredCurrency}{" "}
                                          {detail.convertedTotal.toFixed(2)} */}
                                          {!isFarePriceReady
                                            ? "Loading…"
                                            : `${preferredCurrency} ${Math.round(
                                              detail.convertedTotal
                                            ).toFixed(2)}`}
                                        </p>
                                      </li>
                                    );
                                  }
                                )}
                              </ul>
                            </div>
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <p>DiscountPrice</p>
                                  <p>
                                    {/* {preferredCurrency} {convertedDiscountPrice} */}
                                    {!isFarePriceReady
                                      ? "Loading…"
                                      : `${preferredCurrency} ${Math.round(
                                        convertedDiscountPrice
                                      ).toFixed(2)}`}
                                  </p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseTwo"
                              aria-expanded="true"
                              aria-controls="flush-collapseTwo"
                            >
                              <h3>
                                <img
                                  src={downArrowIco}
                                  className="img-fluid"
                                  alt=""
                                />
                                Taxes, Fee and Surcharges
                              </h3>
                              <h3>
                                {/* {preferredCurrency} {(parseFloat(convertedTaxes) + parseFloat(convertedMarkup)).toFixed(2)} */}
                                {!isFarePriceReady
                                  ? "Loading…"
                                  : `${preferredCurrency} ${(
                                    Math.round(convertedTaxes) +
                                    Math.round(convertedMarkup)
                                  ).toFixed(2)}`}
                              </h3>
                            </button>
                          </h2>
                          <div
                            id="flush-collapseTwo"
                            className="accordion-collapse collapse show"
                          ></div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#flush-collapseThree"
                              aria-expanded="true"
                              aria-controls="flush-collapseThree"
                            >
                              <h3>
                                <img
                                  src={downArrowIco}
                                  className="img-fluid"
                                  alt=""
                                />
                                Other Services
                              </h3>
                            </button>
                          </h2>
                          <div
                            id="flush-collapseThree"
                            className="accordion-collapse collapse show"
                          >
                            <div className="accordion-body">
                              <ul>
                                <li>
                                  <p>Service Charge</p>
                                  <p>
                                    {/* {preferredCurrency} {parseFloat(convertedFixedFee).toFixed(2)} */}
                                    {!isFarePriceReady
                                      ? "Loading…"
                                      : `${preferredCurrency} ${Math.round(
                                        convertedFixedFee
                                      ).toFixed(2)}`}
                                  </p>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="btmTtlWrap">
                        <h2>Total Amount</h2>
                        <h2>
                          {/* {preferredCurrency} {convertedTotalPrice} */}
                          {!isFarePriceReady
                            ? "Loading…"
                            : `${preferredCurrency} ${Math.round(
                              convertedTotalPrice
                            ).toFixed(2)}`}
                        </h2>
                      </div>
                    </div>
                    <div className="additional-baggage-checkbox">
                      <Form.Check
                        type="checkbox"
                        id="requestAdditionalBaggage"
                        label={
                          <span>
                            Request Additional Baggage <br />
                            <small>
                              (Travasco will contact you to confirm your baggage
                              requirement. Additional charges may apply*)
                            </small>
                          </span>
                        }
                        checked={requestAdditionalBaggage}
                        onChange={(e) =>
                          setRequestAdditionalBaggage(e.target.checked)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="btmFlightListWrapFixed">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="totalAmtWrap">
                  <h4>
                    {" "}
                    Total Amount :
                    <span>
                      {" "}
                      {!isFarePriceReady
                        ? "Loading…"
                        : `${preferredCurrency} ${Math.round(
                          convertedTotalPrice
                        ).toFixed(2)}`}
                      {/* {preferredCurrency} {convertedTotalPrice}{" "} */}{" "}
                    </span>
                  </h4>
                  {!isRoundTrip ? (
                    <Link
                      to="/FlightReservationTwo"
                      className="btn"
                      state={{
                        ItemCodeRef: ItemCodeRef,
                        SegmentCodeRefs: SegmentCodeRefs,
                        UniqueTransID: UniqueTransID,
                        PriceCodeRef: PriceCodeRef,
                        Currency: preferredCurrency,
                        TotalPrice: convertedTotalPrice,
                        segments: location.state?.segments || [],
                        routeDetails: location.state?.routeDetails || {},
                      }}
                      onClick={(e) => {
                        const token = localStorage.getItem("b2bToken");
                        if (!token) {
                          e.preventDefault();
                          navigate("/B2BPortal");
                          return;
                        }

                        if (priceChanged) {
                          e.preventDefault();
                          setShowPriceModal(true);
                        }
                        localStorage.setItem(
                          "requestAdditionalBaggage",
                          requestAdditionalBaggage
                        );
                      }}
                    >
                      Continue
                      <svg
                        width="6"
                        height="16"
                        viewBox="0 0 8 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.51172 1.89062L6.94029 11.3906L1.51172 20.8906"
                          stroke="white"
                          strokeWidth="1.80952"
                          strokeLinecap="round"
                        />
                      </svg>
                    </Link>
                  ) : (
                    <Link
                      to="/TwoWayFlights"
                      className="btn"
                      state={{
                        ItemCodeRef,
                        SegmentCodeRefs,
                        UniqueTransID,
                        PriceCodeRef,
                        Currency: preferredCurrency,
                        TotalPrice: convertedTotalPrice,
                        departureSegments,
                        returnSegments,
                        passengerCounts,
                      }}
                      onClick={(e) => {
                        const token = localStorage.getItem("b2bToken");
                        if (!token) {
                          e.preventDefault();
                          navigate("/B2BPortal");
                          return;
                        }

                        if (priceChanged) {
                          e.preventDefault();
                          setShowPriceModal(true);
                        }
                        localStorage.setItem(
                          "requestAdditionalBaggage",
                          requestAdditionalBaggage
                        );
                      }}
                    >
                      Continue
                      <svg
                        width="6"
                        height="16"
                        viewBox="0 0 8 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.51172 1.89062L6.94029 11.3906L1.51172 20.8906"
                          stroke="white"
                          strokeWidth="1.80952"
                          strokeLinecap="round"
                        />
                      </svg>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>

      {/* <Modal
        show={showPriceModal}
        onHide={() => {}}
        backdrop="static"
        keyboard={false}
        className="CancelBookingPopup priceUpdatePopup"
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>Price Update Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="topDifPriceWrap">
            <div className="imgWrap">
              <img src={PriceUpdateImg} className="img-fluid" alt="" />
            </div>
            <div className="dataWrap">
              <p>
                Airline Has {changeText} The Price By{" "}
                <span
                  className={`price-difference
                    ${isIncrease ? "increase" : "decrease"}`}
                >
                 
                   Difference: {isIncrease ? "+" : "-"}
  {preferredCurrency} {Math.abs(difference).toFixed(2)}
                </span>
              </p>
            </div>
          </div>
          <div className="priceListWrap">
            <div className="item">
              <p>Original Price : </p>
              <h3>
                {preferredCurrency} {Math.round(convertedOriginalPrice).toFixed(2)}
              </h3>
            </div>
            <div className="item">
              <p>Current Price : </p>
              <h3>
                {preferredCurrency} {Math.round(convertedTotalPrice).toFixed(2)}
              </h3>
            </div>
          </div>
          <div className="btmDataWrap">
            <p>
              The airline has updated the flight price. Please review the new
              price before proceeding with your booking.
            </p>
          </div>
          <div className="btmCtaWrap">
            <button
              className="btn btnNoClr"
              onClick={() => {
                setShowPriceModal(false);
                navigate(-1);
              }}
            >
              Go Back
            </button>
            <button className="btn" onClick={handleContinueWithNewPrice}>
              Continue with Updated Price
            </button>
          </div>
        </Modal.Body>
      </Modal> */}
      <Modal
        show={showPriceModal}
        onHide={closePriceModal}
        backdrop="static"
        keyboard={false}
        className="CancelBookingPopup priceUpdatePopup"
      >
        <Modal.Header closeButton>
          <Modal.Title>Price Update Notification</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="topDifPriceWrap">
            <div className="imgWrap">
              <img src={PriceUpdateImg} className="img-fluid" alt="" />
            </div>

            <div className="dataWrap">
              <p>
                Airline Has {changeText} The Price By{" "}
                <span
                  className={`price-difference ${isIncrease ? "increase" : "decrease"
                    }`}
                >
                  {isIncrease ? "+" : "-"}
                  {preferredCurrency}{" "} {Math.abs(difference).toFixed(2)}
                </span>
              </p>
            </div>
          </div>

          <div className="priceListWrap">
            <div className="item">
              <p>Original Price :</p>
              <h3>
                {preferredCurrency}{" "}
                {Math.round(convertedOriginalPrice).toFixed(2)}
              </h3>
            </div>

            <div className="item">
              <p>Current Price :</p>
              <h3>
                {preferredCurrency} {" "}{Math.round(convertedTotalPrice).toFixed(2)}
              </h3>
            </div>
          </div>

          <div className="btmDataWrap">
            <p>
              The airline has updated the flight price. Please review the new
              price before proceeding with your booking.
            </p>
          </div>

          <div className="btmCtaWrap">
            <button
              className="btn btnNoClr"
              onClick={() => {
                closePriceModal();
                navigate(-1);
              }}
            >
              Go Back
            </button>

            <button className="btn" onClick={handleContinueWithNewPrice}>
              Continue with Updated Price
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default FlightReservationOne;
